import React, {Component} from 'react';
import AirDatePicker from "../../../../common/components/AirDatePicker";
import {withRouter} from "react-router-dom";
import {inject, observer} from "mobx-react";

import './FilterBar.css'
import {Button, Checkbox, Select} from "antd";
import { api } from '../../../../services';

import AirInLabelSelect from "../../../../common/components/AirInLabelSelect";

const { Option } = Select;

@withRouter
@inject('tripsStore', 'translationsStore')
@observer
export default class FiltersBar extends Component {
  constructor(props) {
    super(props);

    this.state = { plates: [] };
  }

  componentDidMount = () => {
    if (!this.props.isSmall) {
      api('getCarPlates').then(plates => {
        this.setState({ plates: plates });
      });
    }
  };

  handleCarsChange = (value) => {
    if (value.includes('all')) {
      this.props.tripsStore.setSelectedCars([]);
    } else {
      this.props.tripsStore.setSelectedCars(value);
    }
  }

  render() {
    const { tripsStore, translationsStore, isSmall } = this.props;

    const carsOptions = this.state.plates.map(d => <Option key={d.id}>{d.plate}</Option>);

    return <div className="FiltersBar">
      {!isSmall &&<div className="SelectAll"><Checkbox checked={tripsStore.areAllTripsSelected} onChange={tripsStore.selectAllTrips}></Checkbox></div>}
      <div className="DateRangeSelector">
        <AirDatePicker
          selected={tripsStore.startDate}
          onChange={tripsStore.setStartDate}
          selectsStart
          prefix={translationsStore.translate('tripsPanel.filter.date.from')}
          startDate={tripsStore.startDate}
          endDate={tripsStore.endDate}
        />
        <AirDatePicker
          selected={tripsStore.endDate}
          onChange={tripsStore.setEndDate}
          selectsEnd
          prefix={translationsStore.translate('tripsPanel.filter.date.to')}
          startDate={tripsStore.startDate}
          endDate={tripsStore.endDate}
          minDate={tripsStore.startDate}
        />
      </div>
      <Button onClick={tripsStore.resetFilters}>{translationsStore.translate('tripsList.filter.reset')}</Button>
      {!isSmall && <AirInLabelSelect
        label={translationsStore.translate('tripsList.filter.vehicle.label')}
        mode="multiple"
        value={tripsStore.selectedCars}
        onChange={this.handleCarsChange}
        filterOption={true}
        optionFilterProp="children"
      >
        <Option value="all">{translationsStore.translate('tripsList.filter.vehicle.all')}</Option>
        {carsOptions}
      </AirInLabelSelect>}
      <AirInLabelSelect
        label={translationsStore.translate('tripsList.filter.sorting.label')}
        value={tripsStore.sorting}
        onChange={tripsStore.setSorting}
      >
          <Option value="newest">{translationsStore.translate('tripsList.filter.sorting.newest')}</Option>
          <Option value="oldest">{translationsStore.translate('tripsList.filter.sorting.oldest')}</Option>
          <Option value="dist_d">{translationsStore.translate('tripsList.filter.sorting.distanceDesc')}</Option>
          <Option value="dist_a">{translationsStore.translate('tripsList.filter.sorting.distanceAsc')}</Option>
          <Option value="duration_d">{translationsStore.translate('tripsList.filter.sorting.durationDesc')}</Option>
          <Option value="duration_a">{translationsStore.translate('tripsList.filter.sorting.durationAsc')}</Option>
      </AirInLabelSelect>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/App/Trips/FiltersBar/FiltersBar.js